import React, { Component } from 'react';
import styled from 'styled-components';

import Color from '../../utils/colors';
import { Font, FontWeight } from '../../utils/fonts';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

class Headline extends Component {
    render() {
        const { className, children, page } = this.props;

        return (
            <Root className={className} page={page}>
                {children}
            </Root>
        );
    }
}

const Root = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: ${({ page }) => (page ? '40px' : '24px')};
    line-height: ${({ page }) => (page ? '40px' : '24px')};

    color: ${Color.TEXT_PRIMARY};
    text-transform: uppercase;

    ${mediaWidth.m} {
        font-size: 32px;
        line-height: 32px;
    }
`;

export default Headline;
